module.exports = __webpack_public_path__ + "static/media/video_high_spa.eb7cec77.mp4";